import { IUserResponses, IResponsesValue } from 'types'

export const SET_USER_RESPONSES = 'userResponsesManagerComponent.setUserResponses'
export const SET_IS_LOADING_RESPONSES = 'userResponsesManagerComponent.setIsLoadingResponses'
export const SET_IS_UPDATING_RESPONSE = 'userResponsesManagerComponent.setIsUpdatingResponse'
export const SET_RESPONSE_LOCALLY = 'userResponsesManagerComponent.setResponseLocally'
export const SET_VALIDATION_AND_TOTALS = 'userResponsesManagerComponent.setValidationAndTotals'
export const RESET = 'userResponsesManagerComponent.reset'

export function setUserResponses(userResponses: IUserResponses | null) {
  return {
    type: SET_USER_RESPONSES,
    payload: userResponses
  } as const
}

export function setIsLoadingResponses(isLoadingResponses: boolean) {
  return {
    type: SET_IS_LOADING_RESPONSES,
    payload: isLoadingResponses
  } as const
}

export function setIsUpdatingResponse(isUpdatingResponse: boolean) {
  return {
    type: SET_IS_UPDATING_RESPONSE,
    payload: isUpdatingResponse
  } as const
}

export function setResponseLocally(responses: Partial<IResponsesValue>) {
  return {
    type: SET_RESPONSE_LOCALLY,
    payload: responses
  } as const
}

export function setValidationAndTotals(responses: IUserResponses) {
  return {
    type: SET_VALIDATION_AND_TOTALS,
    payload: responses
  } as const
}

export function reset() {
  return {
    type: RESET,
    payload: {}
  } as const
}

export type UserResponsesManagerAction = ReturnType<
  | typeof setIsUpdatingResponse
  | typeof setUserResponses
  | typeof setIsLoadingResponses
  | typeof setResponseLocally
  | typeof setValidationAndTotals
  | typeof reset
>
